import React from "react";

const PrivacyPolicies = () => {
  return (
    <div style={{ padding: "40px 200px" }}>
      <div class="main-page-wrapper">
        <div class="dc-description">
          <h1>
            <b>Política de privacidad</b>
          </h1>
          <p>
            <span style={{"font-weight": "400"}}>
              Fecha efectiva: 17 de febrero de 2023
            </span>
          </p>
          <p>
            <span style={{"font-weight": "400"}}>
              En LA PLATAFORMA estamos comprometidos a proteger su privacidad y
              tomamos gran cuidado con su información personal que recopilamos
              cuando usted accede o utiliza 24siete.app y sitios web,
              aplicaciones y servicios relacionados propiedad y operados por LA
              PLATAFORMA y que se vinculan con esta Política de privacidad. Esta
              Política de privacidad está destinada a ayudar a LOS USUARIOS,
              aquellos que usan nuestros Servicios para explorar proveedores o
              reservar citas y médicos, dentistas u otros especialistas,
              profesionales, proveedores, organizaciones o agentes de atención
              médica o afiliados de los mismos que usan nuestros servicios de
              marketing a entender cómo tratamos su información personal.{" "}
            </span>
            <b>
              AL UTILIZAR O ACCEDER A LOS SERVICIOS DE CUALQUIER MANERA, USTED
              RECONOCE QUE ACEPTA LAS PRÁCTICAS Y POLÍTICAS DESCRITAS EN ESTA
              POLÍTICA DE PRIVACIDAD, Y POR LA PRESENTE CONSENTIMOS QUE
              RECOPILAREMOS, USAREMOS Y COMPARTIREMOS SU INFORMACIÓN DE LAS
              SIGUIENTES MANERAS. SI NO ESTÁ DE ACUERDO CON ESTA POLÍTICA DE
              PRIVACIDAD, NO PUEDE UTILIZAR LOS SERVICIOS. SI UTILIZA LOS
              SERVICIOS EN NOMBRE DE ALGUIEN MÁS (COMO SU HIJO) O UNA ENTIDAD
              (COMO SU EMPLEADOR), USTED DECLARA QUE ESTÁ AUTORIZADO POR DICHA
              PERSONA O ENTIDAD PARA ACEPTAR ESTA POLÍTICA DE PRIVACIDAD EN
              NOMBRE DE DICHA PERSONA O ENTIDAD.
            </b>
            <span style={{"font-weight": "400"}}>
              {" "}
              Cualquier uso de los Servicios de LA PLATAFORMA está sujeto en
              todo momento{" "}
            </span>
            <span style={{"font-weight": "400"}}>
              al Acuerdo en nuestros{" "}
              <a
                href="https://24siete.app/terminos-de-uso/"

                rel="noopener"
              >
                Términos de Uso{" "}
              </a>
            </span>
            <span style={{"font-weight": "400"}}>
              que incorpora esta Política de privacidad. Puede imprimir una
              copia de esta Política de privacidad haciendo clic aquí. Muchas
              gracias por elegir 24siete.app.
            </span>
          </p>
          <h1>
            <b>Tabla de contenidos de la política de privacidad</b>
          </h1>
          <ul>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>Datos Personales</span>
              <ul>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Datos Personales del Usuario
                  </span>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="3">
                      <span style={{"font-weight": "400"}}>
                        Categorías de Datos Personales que Recopilamos
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="3">
                      <span style={{"font-weight": "400"}}>
                        Categorías de Fuentes de Datos Personales
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="3">
                      <span style={{"font-weight": "400"}}>
                        Propósitos Comerciales para la Recopilación de Datos
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="3">
                      <span style={{"font-weight": "400"}}>
                        Cómo Compartimos sus Datos Personales
                      </span>
                    </li>
                  </ul>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Datos Personales del Proveedor de Atención Médica
                  </span>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="3">
                      <span style={{"font-weight": "400"}}>
                        Categorías de Datos Personales que Recopilamos
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="3">
                      <span style={{"font-weight": "400"}}>
                        Categorías de Fuentes de Datos Personales
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="3">
                      <span style={{"font-weight": "400"}}>
                        Propósitos Comerciales para la Recopilación de Datos
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="3">
                      <span style={{"font-weight": "400"}}>
                        Cómo Compartimos sus Datos Personales
                      </span>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>
                Herramientas de Seguimiento, Publicidad y Opt-Out
              </span>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>
                Seguridad y Retención de Datos
              </span>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>Privacidad de los Niños</span>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>
                Cómo Usamos la Información que no son datos personales
              </span>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>
                Controlando sus Datos Personales y Notificaciones
              </span>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>Ejerciendo sus Derechos</span>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>
                Cambios en esta Política de Privacidad
              </span>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>Información de Contacto</span>
            </li>
          </ul>
          <p>&nbsp;</p>
          <h3>
            <span style={{"font-weight": "400"}}>Datos personales</span>
          </h3>
          <p>
            <span style={{"font-weight": "400"}}>
              Las siguientes subsecciones detallan las categorías de Datos
              personales que recopilamos y hemos recopilado en los últimos doce
              (12) meses. «Datos personales» significa cualquier información que
              identifique o se relacione con un individuo en particular e
              incluye información referida como «información de identificación
              personal» o «información personal» según las leyes, reglas o
              regulaciones aplicables de privacidad de datos. Para cada
              categoría de Datos personales, estas subsecciones también
              establecen la fuente de esos Datos personales, nuestro propósito
              comercial o empresarial para recopilar esos Datos personales y las
              categorías de terceros con quienes compartimos esos Datos
              personales. Se proporciona más información sobre esas fuentes y
              categorías a continuación.
            </span>
          </p>
          <h3>
            <span style={{"font-weight": "400"}}>Datos personales del usuario</span>
          </h3>
          <p>
            <b>
              LAS SIGUIENTES SUBSECCIONES SE APLICAN SOLO A LOS USUARIOS. SI
              USTED ES UN PROVEEDOR DE ATENCIÓN MÉDICA, CONSULTE LA SECCIÓN DE{" "}
            </b>
            <b>DATOS PERSONALES DEL PROVEEDOR DE ATENCIÓN MÉDICA</b>
            <b> A CONTINUACIÓN.</b>
          </p>
          <p>&nbsp;</p>
          <p>
            <b>Categorías de datos personales que recopilamos</b>
            <b></b>
          </p>
          <p>&nbsp;</p>
          <table>
            <tbody>
              <tr>
                <td colspan="2">
                  <b>Categoría de Datos Personales</b>
                </td>
                <td colspan="2">
                  <b>Ejemplos de datos personales Recopilados</b>
                </td>
                <td colspan="2">
                  <b>Fuente</b>
                </td>
                <td colspan="2">
                  <b>
                    Terceros con los que compartimos datos con fines Comerciales
                  </b>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <b>Información del pago</b>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Tipo de tarjeta de pago
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Últimos cuatro dígitos de la tarjeta de pago
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Contacto de facturación
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Correo Electrónico de Facturas
                      </span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicios (específicamente, nuestro
                        actual socio de procesamiento de pagos, Banco Mercantil.
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <b>Información del dispositivo/IP</b>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Dirección IP</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Identificación del dispositivo
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Servidor de dominio</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Tipo de dispositivo/sistema operativo/navegador
                        utilizado para acceder a los Servicios
                      </span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Terceros</span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Socios de análisis</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Redes publicitarias</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Socios comerciales externos a los que accede a través de
                        los Servicios
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <b>Web Análisis</b>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Interacciones de la página web
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Página web/fuente de referencia a través de la cual
                        accede a los Servicios
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        ID de solicitud no identificables
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Estadísticas asociadas a la interacción entre
                        dispositivo o navegador y los Servicios
                      </span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Terceros</span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Socios de análisis</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Redes publicitarias</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Socios comerciales externos a los que accede a través
                        del Servicio
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <b>Datos de geolocalización</b>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Información de ubicación basada en direcciones IP
                      </span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Socios de análisis</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Redes publicitarias</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Socios comerciales externos a los que accede a través
                        del Servicio
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <b>
                    Otra información de identificación que elija proporcionar
                    voluntariamente
                  </b>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Identificadores únicos como contraseñas
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Datos personales en correos electrónicos, cartas u otras
                        comunicaciones que nos envíe
                      </span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <b>Datos de contacto del usuario</b>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Nombre y apellido</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Correo electrónico</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Número de teléfono</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Dirección de envio</span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Redes publicitarias</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicios de salud
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de seguros
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Intercambios de información de salud
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Partes a las que usted autoriza, accede o autentica
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <b>Datos demográficos del usuario</b>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Género o identidad de género
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Años</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Fecha de nacimiento</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Código postal</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>La raza</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Orientación sexual</span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Redes publicitarias</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicios de salud
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Intercambios de información de salud
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Partes a las que usted autoriza, accede o autentica
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <b>Data Médica</b>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Condiciones de salud
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de atención médica visitados
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Motivos de la visita
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Fechas de visita</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Historial médico e información de salud que nos
                        proporcione
                      </span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicios de salud
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de seguros
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Intercambios de información de salud
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Partes a las que usted autoriza, accede o autentica
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <b>Información del seguro</b>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Compañía de seguros</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Plan de seguro</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Identificación de miembro
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Identificación del grupo
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Identificación del pagador
                      </span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicios de salud
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Intercambios de información de salud
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Partes a las que usted autoriza, accede o autentica
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <b>Datos de la cita de reserva</b>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Fecha/hora de la cita
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Información del proveedor
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Procedimiento de cita
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Si el usuario es o no un paciente nuevo para un
                        proveedor en particular
                      </span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Terceros</span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Socios de análisis</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicios de salud
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Intercambios de información de salud
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <b>Datos de redes sociales</b>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Correo electrónico</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Número de teléfono</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Nombre de usuario</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Dirección IP</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Identificación del dispositivo
                      </span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                  </ul>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Terceros</span>
                    </li>
                  </ul>
                </td>
                <td colspan="2">
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Redes publicitarias</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        • Partes a las que usted autoriza, accede o autentica
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
          <p>&nbsp;</p>
          <p>
            <b>Categorías de Fuentes de Datos Personales</b>
          </p>
          <p>&nbsp;</p>
          <table>
            <thead>
              <tr>
                <th colspan="2">
                  <b>Categorías de Fuentes de Datos Personales</b>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">
                  <b>De ti</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>Cuando nos proporciona información directamente</b>
                </td>
                <td>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Cuando creas una cuenta o usas nuestras herramientas y
                        servicios interactivos, como buscar proveedores de
                        atención médica o citas disponibles con proveedores de
                        atención médica y completar formularios de historial
                        médico antes de las citas con proveedores de atención
                        médica.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Cuando proporcionas voluntariamente información en
                        cuadros de texto de formato libre a través de los
                        Servicios o a través de respuestas a encuestas y
                        cuestionarios, o publicas reseñas.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Cuando nos envías un correo electrónico o te pones en
                        contacto con nosotros de otra manera.
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <b>
                    Cuando los datos personales se recopilan automáticamente
                    cuando utiliza los servicios
                  </b>
                </td>
                <td>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        A través de Cookies (definidas a continuación).
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Si descarga e instala determinadas aplicaciones y
                        software que ponemos a su disposición, podemos recibir y
                        recopilar información transmitida desde su dispositivo
                        informático con el fin de proporcionarle los Servicios
                        pertinentes, como información sobre cuándo está
                        conectado y disponible para recibir actualizaciones o
                        avisos de alerta.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Si descarga nuestra aplicación móvil o utiliza un
                        navegador habilitado para ubicación, podemos recibir
                        información sobre su ubicación y dispositivo móvil,
                        según corresponda.
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <b>De terceros</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>Proveedores de servicio</b>
                </td>
                <td>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Podemos utilizar proveedores de servicios para analizar
                        cómo interactúa y se relaciona con los Servicios, o para
                        ayudarnos a brindarle atención al cliente.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Podemos utilizar proveedores de servicios para obtener
                        información para generar clientes potenciales y crear
                        perfiles de usuario
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <b>Socios de análisis</b>
                </td>
                <td>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Podemos trabajar con socios de análisis para que nos
                        proporcionen análisis sobre el tráfico del sitio web o
                        el uso de los Servicios.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Utilizamos estos datos para optimizar y comercializar
                        nuestros Servicios.
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <b>Proveedores de servicios de salud</b>
                </td>
                <td>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Es posible que recibamos ciertos datos de su(s)
                        proveedor(es) de atención médica para facilitar la
                        reserva de citas.
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <b>redes sociales</b>
                </td>
                <td>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Si nos proporciona las credenciales de su cuenta de red
                        social o inicia sesión en los Servicios a través de un
                        sitio o servicio de un tercero, comprende que parte del
                        contenido y/o información de esas cuentas puede
                        transmitirse a su cuenta con nosotros.
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <b>Socios publicitarios</b>
                </td>
                <td>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Recibimos información sobre usted de algunos de nuestros
                        proveedores de servicios que nos ayudan con servicios
                        promocionales o de marketing relacionados con la forma
                        en que interactúa con nuestros Servicios, anuncios o
                        comunicaciones.
                      </span>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
          <p>&nbsp;</p>
          <p>
            <span style={{"font-weight": "400"}}>
              Propósitos comerciales o empresariales para la recolección de
              datos
            </span>
          </p>
          <ul>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>
                Proveer, personalizar y mejorar los servicios&nbsp;
              </span>
              <ul>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Crear y administrar su cuenta u otros perfiles de usuario.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Facturar a nuestros clientes proveedores de atención médica.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Proporcionarle los productos, servicios e información que
                    solicite.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Cumplir o satisfacer la razón por la que nos proporcionó la
                    información.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Proporcionar soporte y asistencia para los servicios.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Mejorar los servicios, incluyendo pruebas, investigación,
                    análisis interno y desarrollo de productos.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Personalizar los servicios, el contenido del sitio web y las
                    comunicaciones en función de sus preferencias.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Protección contra fraudes, seguridad y depuración.
                  </span>
                </li>
              </ul>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>
                Marketing de los servicios&nbsp;
              </span>
              <ul>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Marketing y venta de servicios.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Mostrarle anuncios, incluyendo publicidad basada en
                    intereses o comportamiento en línea.
                  </span>
                </li>
              </ul>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>
                Correspondencia con usted&nbsp;
              </span>
              <ul>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Responder a la correspondencia que recibimos de usted,
                    contactarlo cuando sea necesario o solicitado, incluyendo
                    recordatorios de citas pendientes y enviarle información
                    sobre LA PLATAFORMA o los servicios.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Enviar correos electrónicos y otras comunicaciones que
                    muestren contenido que creemos que le interesará y según sus
                    preferencias, incluyendo la notificación sobre ciertos
                    recursos, proveedores de atención médica o servicios.
                  </span>
                </li>
              </ul>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>Requisitos legales&nbsp;</span>
              <ul>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Cumplir con nuestras obligaciones legales según la ley
                    aplicable, regulación, orden judicial u otro proceso legal,
                    como prevenir, detectar e investigar incidentes de seguridad
                    y actividades potencialmente ilegales o prohibidas.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Proteger los derechos, propiedad o seguridad de usted, LA
                    PLATAFORMA o otra parte.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Hacer cumplir cualquier acuerdo con usted.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Responder a reclamos que cualquier publicación u otro
                    contenido viola los derechos de terceros.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>Resolver disputas.</span>
                </li>
              </ul>
            </li>
          </ul>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <h3>
            <span style={{"font-weight": "400"}}>
              Cómo compartimos sus datos personales
            </span>
          </h3>
          <p>
            <span style={{"font-weight": "400"}}>
              En determinadas circunstancias, podemos compartir sus Datos
              personales con las siguientes categorías de proveedores de
              servicios y otros terceros para los fines comerciales indicados:
            </span>
          </p>
          <p>&nbsp;</p>
          <table>
            <thead>
              <tr>
                <th>
                  <b>
                    Categorías de terceros con los que compartimos datos
                    personales
                  </b>
                </th>
                <th>
                  <b>Propósito comercial para compartir datos</b>
                </th>
              </tr>
              <tr>
                <th colspan="2">
                  <b>Proveedores de servicio</b>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Procesadores de pago</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Nuestro socio de procesamiento de pagos, actualmente
                        Banco Mercantil
                      </span>{" "}
                      <span style={{"font-weight": "400"}}>
                        recopila la información de su tarjeta de pago
                        proporcionada voluntariamente necesaria para procesar su
                        pago.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Consulte los términos de servicio y la política de
                        privacidad del Banco Mercantil para obtener información
                        sobre su uso y almacenamiento de datos personales.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Consultores de Seguridad y Prevención de Fraude</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Detectar incidentes de seguridad, proteger contra
                        actividades maliciosas, engañosas, fraudulentas o
                        ilegales, y enjuiciar a los responsables de esa
                        actividad.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Proveedores de Hosting, Tecnología y Comunicaciones;</b>
                  <p></p>
                  <p>
                    <b>Proveedores de Cumplimiento;</b>
                  </p>
                  <p>
                    <b>proveedores de almacenamiento de datos;</b>
                  </p>
                  <p>
                    <b>Proveedores de análisis;</b>
                  </p>
                  <p>
                    <b>Proveedores de Verificación de Seguros;</b>
                  </p>
                  <p>
                    <b>Personal de aumento de personal</b>
                  </p>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Para realizar servicios operativos (como hospedaje,
                        facturación, cumplimiento, almacenamiento de datos,
                        seguridad, verificación de seguros, análisis de
                        servicios web) y/o poner ciertos servicios,
                        características o funcionalidades a disposición de
                        nuestros Usuarios.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Depuración para identificar y reparar errores que
                        perjudican la funcionalidad prevista.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Uso transitorio a corto plazo de Datos personales que no
                        es utilizado por otra parte para crear un perfil de
                        Usuario o alterar su experiencia de usuario fuera de la
                        interacción actual.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Prestar servicios en nuestro nombre, incluido el
                        mantenimiento o el servicio de cuentas, la prestación de
                        servicio al cliente, el procesamiento o el cumplimiento
                        de pedidos y transacciones, la verificación de la
                        información del cliente, el procesamiento de pagos, la
                        prestación de financiación, la prestación de servicios
                        de publicidad o marketing, la prestación de servicios
                        analíticos o la prestación de servicios similares en
                        nombre de el negocio o proveedor de servicios.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Realización de investigaciones internas para el
                        desarrollo tecnológico y la demostración.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Llevar a cabo actividades para verificar o mantener la
                        calidad o seguridad de nuestros Servicios.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th colspan="2">
                  <b>Destinatarios seleccionados</b>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Socios de análisis</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Para rastrear cómo los usuarios encontraron o fueron
                        referidos a los Servicios e interactuar con los
                        Servicios.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Redes publicitarias</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Personalización y publicación de anuncios.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Auditoría relacionada con una interacción actual y
                        transacciones simultáneas, incluidas, entre otras, el
                        recuento de impresiones de anuncios para visitantes
                        únicos, la verificación del posicionamiento y la calidad
                        de las impresiones de anuncios, y la auditoría del
                        cumplimiento de esta especificación y otras normas.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Proveedores de servicios de salud</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de atención médica con los que los Usuarios
                        eligen programar a través de los Servicios.&nbsp;Por
                        ejemplo, si completa un Formulario de historial médico
                        utilizando los Servicios antes de una cita y elige
                        compartirlo con su Proveedor de atención médica
                        seleccionado.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Si elige utilizar los Servicios correspondientes, los
                        Proveedores de atención médica para permitirles
                        derivarlo y programar citas con otros Proveedores de
                        atención médica en su nombre o para realizar análisis
                        sobre posibles problemas de salud o tratamientos.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        En caso de emergencia.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Proveedores de seguros</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Para determinar la elegibilidad y las obligaciones de
                        costos compartidos, y para obtener información sobre el
                        plan de beneficios en su nombre.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Intercambios de información de salud</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Los intercambios de información de salud y las
                        organizaciones relacionadas que recopilan y organizan la
                        información del usuario (como las organizaciones
                        regionales de información de salud) para que sus
                        proveedores de atención médica puedan acceder a su
                        información de manera más segura y fácil.&nbsp;El
                        objetivo de tales organizaciones es facilitar el acceso
                        a la información de salud para mejorar la seguridad,
                        calidad y eficiencia de la atención centrada en el
                        paciente.&nbsp;
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th colspan="2">
                  <b>Partes a las que autoriza, accede o autentica</b>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Otros usuarios</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Cualquier información que pueda revelar en una
                        publicación de revisión o discusión o foro en línea está
                        intencionalmente abierta al público y no es de ninguna
                        manera privada.&nbsp;Le recomendamos que considere
                        detenidamente si divulga cualquier Dato personal en
                        cualquier publicación o foro público.&nbsp;Lo que ha
                        escrito puede ser visto y/o recopilado por terceros y
                        puede ser utilizado por otros en formas que no podemos
                        controlar o predecir.&nbsp;&nbsp;
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>
                    Socios comerciales externos a los que accede a través de los
                    Servicios
                  </b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Compartiremos ciertos Datos personales si elige utilizar
                        cualquier servicio para iniciar sesión en los Servicios.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Para cumplir o cumplir con el motivo por el que nos
                        proporcionó la información.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
            </thead>
          </table>
          <p>&nbsp;</p>
          <p>
            <b>Datos personales del proveedor de atención médica</b>
          </p>
          <p>
            <b>
              LAS SIGUIENTES SUBSECCIONES SE APLICAN ÚNICAMENTE A LOS
              PROVEEDORES DE ATENCIÓN MÉDICA.&nbsp;SI USUARIO, CONSULTE LA
              SECCIÓN&nbsp;
            </b>
            <b>DE DATOS PERSONALES DEL USUARIO</b>
            <b>&nbsp;ANTERIOR.</b>
          </p>
          <h3>
            <span style={{"font-weight": "400"}}>
              Categorías de datos personales que recopilamos
            </span>
          </h3>
          <table>
            <thead>
              <tr>
                <th>
                  <b>Categoría de Datos Personales</b>
                </th>
                <th>
                  <b>Ejemplos de datos personales recopilados</b>
                </th>
                <th>
                  <b>Fuente</b>
                </th>
                <th>
                  <b>
                    Terceros con los que compartimos datos con fines comerciales
                  </b>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Información del pago</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        tipo de tarjeta de pago
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Últimos cuatro dígitos de la tarjeta de pago
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Contacto de facturación
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Correo Electrónico de Facturas
                      </span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicios (específicamente, nuestro
                        actual socio de procesamiento de pagos, Banco Mercantil)
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Información del dispositivo/IP</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>dirección IP</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Identificación del dispositivo
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>servidor de dominio</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Tipo de dispositivo/sistema operativo/navegador
                        utilizado para acceder a los Servicios
                      </span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Terceros</span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Socios de análisis</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Redes publicitarias</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Socios comerciales externos a los que accede a través de
                        los Servicios
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>analista de la red</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Interacciones de la página web
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Página web/fuente de referencia a través de la cual
                        accede a los Servicios
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        ID de solicitud no identificables
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Estadísticas asociadas a la interacción entre
                        dispositivo o navegador y los Servicios
                      </span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Terceros</span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Socios de análisis</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Redes publicitarias</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Socios comerciales externos a los que accede a través
                        del servicio
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Datos de geolocalización</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Información de ubicación basada en direcciones IP
                      </span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Terceros</span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Socios de análisis</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Redes publicitarias</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Socios comerciales externos a los que accede a través
                        del servicio
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>
                    Otra información de identificación que elija proporcionar
                    voluntariamente
                  </b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Identificadores únicos como contraseñas
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Datos personales en correos electrónicos o cartas que
                        nos envíe
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Información personal que divulgas por teléfono
                      </span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Datos de contacto del proveedor de atención médica</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Nombre y apellido</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Correo electrónico</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Número de teléfono</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Dirección de envio</span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Terceros</span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Redes publicitarias</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicios de salud
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de seguros
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Intercambios de información de salud
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Partes a las que autoriza, accede o autentica
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Datos demográficos del proveedor de atención médica</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Género o identidad de género
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Años</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Fecha de nacimiento</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Código postal</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>La raza</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>orientación sexual</span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Terceros</span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Redes publicitarias</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicios de salud
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Intercambios de información de salud
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Partes a las que autoriza, accede o autentica
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Información de licencia profesional</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        licencias profesionales
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Historia de la Educación
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Especialidades y certificaciones
                      </span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Tú</span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>Terceros</span>
                    </li>
                  </ul>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Proveedores de servicio
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
            </thead>
          </table>
          <p>&nbsp;</p>
          <h3>
            <span style={{"font-weight": "400"}}>
              Categorías de Fuentes de Datos Personales
            </span>
          </h3>
          <p>&nbsp;</p>
          <table>
            <thead>
              <tr>
                <th colspan="2">
                  <b>Categorías de Fuentes de Datos Personales</b>
                </th>
              </tr>
              <tr>
                <th colspan="2">
                  <b>De ti</b>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Cuando nos proporciona información directamente</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Cuando creas una cuenta.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Cuando nos envía un correo electrónico o se pone en
                        contacto con nosotros.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>
                    Cuando los datos personales se recopilan automáticamente
                    cuando utiliza los servicios
                  </b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        A través de Cookies (definidas a continuación).
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Si descarga e instala determinadas aplicaciones y
                        software que ponemos a su disposición, podemos recibir y
                        recopilar información transmitida desde su dispositivo
                        informático con el fin de proporcionarle los Servicios
                        pertinentes, como información sobre cuándo ha iniciado
                        sesión y está disponible para recibir actualizaciones o
                        alertas. avisos
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Si descarga nuestra aplicación móvil o utiliza un
                        navegador habilitado para ubicación, podemos recibir
                        información sobre su ubicación y dispositivo móvil,
                        según corresponda.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th colspan="2">
                  <b>De terceros</b>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Proveedores de servicio</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Podemos utilizar proveedores de servicios para analizar
                        cómo interactúa y se involucra con los Servicios, o para
                        ayudarnos a brindarle atención al cliente.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Podemos utilizar proveedores de servicios para obtener
                        información para generar clientes potenciales y crear
                        perfiles de usuario.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Socios de análisis</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Podemos trabajar con socios de análisis para que nos
                        proporcionen análisis sobre el tráfico del sitio web o
                        el uso de los Servicios.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Utilizamos estos datos para optimizar y comercializar
                        nuestros Servicios.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Registros gubernamentales o públicos</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Podemos usar registros gubernamentales u otros registros
                        públicos para incorporar o verificar proveedores de
                        atención médica.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Socios publicitarios</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Recibimos información sobre usted de algunos de nuestros
                        proveedores de servicios que nos ayudan con servicios
                        promocionales o de marketing relacionados con la forma
                        en que interactúa con nuestros Servicios, anuncios o
                        comunicaciones.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
            </thead>
          </table>
          <p>&nbsp;</p>
          <h3>
            <span style={{"font-weight": "400"}}>
              Fines comerciales o empresariales para recopilar datos
            </span>
          </h3>
          <ul>
            <li style={{"font-weight": "400"}} aria-level="1">
              <h3>
                <span style={{"font-weight": "400"}}>
                  Proporcionar, personalizar y mejorar los servicios
                </span>
              </h3>
              <ul>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Creación y gestión de su cuenta u otros perfiles de usuario,
                    facturación.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Proporcionarle los productos, servicios e información que
                    solicita.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Cumplir o cumplir el motivo por el cual nos proporcionó la
                    información.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Proporcionar soporte y asistencia para los Servicios.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Mejorar los Servicios, incluidas las pruebas, la
                    investigación, el análisis interno y el desarrollo de
                    productos.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Personalizar los Servicios, el contenido del sitio web y las
                    comunicaciones en función de sus preferencias.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Protección contra fraude, seguridad y depuración.
                  </span>
                </li>
              </ul>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <h3>
                <span style={{"font-weight": "400"}}>
                  Comercialización de los Servicios
                </span>
              </h3>
              <ul>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Comercialización y venta de los Servicios.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Mostrarle publicidad, incluida la publicidad conductual en
                    línea o basada en intereses.
                  </span>
                </li>
              </ul>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <h3>
                <span style={{"font-weight": "400"}}>correspondencia con usted</span>
              </h3>
              <ul>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Responder a la correspondencia que recibimos de usted,
                    contactarlo cuando sea necesario o solicitado, incluso para
                    recordarle una próxima cita y enviarle información sobre LA
                    PLATAFORMA o los Servicios.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Enviar correos electrónicos y otras comunicaciones que
                    muestren contenido que creemos que le interesará y de
                    acuerdo con sus preferencias, incluida la notificación sobre
                    ciertos recursos, proveedores de atención médica o
                    servicios.
                  </span>
                </li>
              </ul>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <h3>
                <span style={{"font-weight": "400"}}>Requerimientos legales</span>
              </h3>
              <ul>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Cumplir con nuestras obligaciones legales en virtud de las
                    leyes, reglamentos, órdenes judiciales u otros procesos
                    legales aplicables, como prevenir, detectar e investigar
                    incidentes de seguridad y actividades potencialmente
                    ilegales o prohibidas.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Proteger los derechos, la propiedad o la seguridad de usted,
                    LA PLATAFORMA o de otra parte.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Hacer cumplir cualquier acuerdo con usted.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Responder a reclamos de que cualquier publicación u otro
                    contenido viola los derechos de terceros.
                  </span>
                </li>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>Resolviendo disputas.</span>
                </li>
              </ul>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <h3>
                <span style={{"font-weight": "400"}}>
                  Verificación de incorporación
                </span>
              </h3>
              <ul>
                <li style={{"font-weight": "400"}} aria-level="2">
                  <span style={{"font-weight": "400"}}>
                    Los proveedores de confirmación tienen las credenciales
                    necesarias para practicar en el estado donde se anuncian.
                  </span>
                </li>
              </ul>
            </li>
          </ul>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <h3>
            <span style={{"font-weight": "400"}}>
              Cómo compartimos sus datos personales
            </span>
          </h3>
          <p>
            <span style={{"font-weight": "400"}}>
              En determinadas circunstancias, podemos compartir sus Datos
              personales con las siguientes categorías de proveedores de
              servicios y otros terceros para los fines comerciales indicados:
            </span>
          </p>
          <p>&nbsp;</p>
          <table>
            <thead>
              <tr>
                <th>
                  <b>
                    Categorías de terceros con los que compartimos datos
                    personales
                  </b>
                </th>
                <th>
                  <b>Propósito comercial para compartir datos</b>
                </th>
              </tr>
              <tr>
                <th colspan="2">
                  <b>Proveedores de servicio</b>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Procesadores de pago</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Nuestro socio de procesamiento de pagos, actualmente
                        Banco Mercantil recopila la información de su tarjeta de
                        pago proporcionada voluntariamente necesaria para
                        procesar su pago.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Consulte los términos de servicio y la política de
                        privacidad de Banco Mercantil para obtener información
                        sobre su uso y almacenamiento de datos personales.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Consultores de Seguridad y Prevención de Fraude</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Detectar incidentes de seguridad, proteger contra
                        actividades maliciosas, engañosas, fraudulentas o
                        ilegales, y enjuiciar a los responsables de esa
                        actividad.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Proveedores de Hosting, Tecnología y Comunicaciones;</b>
                  <p></p>
                  <p>
                    <b>Proveedores de Cumplimiento;</b>
                  </p>
                  <p>
                    <b>proveedores de almacenamiento de datos;</b>
                  </p>
                  <p>
                    <b>Proveedores de análisis;</b>
                  </p>
                  <p>
                    <b>Proveedores de Verificación de Seguros;</b>
                  </p>
                  <p>
                    <b>Personal de aumento de personal</b>
                  </p>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Para realizar servicios operativos (como hospedaje,
                        facturación, cumplimiento, almacenamiento de datos,
                        seguridad, verificación de seguros, análisis de
                        servicios web) y/o poner ciertos servicios,
                        características o funcionalidades a disposición de
                        nuestros Usuarios.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Depuración para identificar y reparar errores que
                        perjudican la funcionalidad prevista existente.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Uso transitorio a corto plazo de Datos personales que no
                        es utilizado por otra parte para crear un perfil de
                        Usuario o alterar su experiencia de usuario fuera de la
                        interacción actual.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Prestar servicios en nuestro nombre, incluido el
                        mantenimiento o el servicio de cuentas, la prestación de
                        servicio al cliente, el procesamiento o el cumplimiento
                        de pedidos y transacciones, la verificación de la
                        información del cliente, el procesamiento de pagos, la
                        prestación de financiación, la prestación de servicios
                        de publicidad o marketing, la prestación de servicios
                        analíticos o la prestación de servicios similares en
                        nombre del negocio o proveedor de servicios.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Realización de investigaciones internas para el
                        desarrollo tecnológico y la demostración.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Llevar a cabo actividades para verificar o mantener la
                        calidad o seguridad de nuestros Servicios.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th colspan="2">
                  <b>Destinatarios seleccionados</b>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Socios de análisis</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Para rastrear cómo los usuarios encontraron o fueron
                        referidos a los Servicios e interactuar con los
                        Servicios.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Redes publicitarias</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Personalización y publicación de anuncios.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Auditoría relacionada con una interacción actual y
                        transacciones simultáneas, incluidas, entre otras, el
                        recuento de impresiones de anuncios para visitantes
                        únicos, la verificación del posicionamiento y la calidad
                        de las impresiones de anuncios, y la auditoría del
                        cumplimiento de esta especificación y otras normas.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th>
                  <b>Intercambios de información de salud</b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Los intercambios de información de salud y las
                        organizaciones relacionadas que recopilan y organizan la
                        información del usuario (como las organizaciones
                        regionales de información de salud) para que sus
                        proveedores de atención médica puedan acceder a su
                        información de manera más segura y fácil.&nbsp;El
                        objetivo de tales organizaciones es facilitar el acceso
                        a la información de salud para mejorar la seguridad,
                        calidad y eficiencia de la atención centrada en el
                        paciente.&nbsp;
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
              <tr>
                <th colspan="2">
                  <b>Partes a las que autoriza, accede o autentica</b>
                </th>
              </tr>
              <tr>
                <th>
                  <b>
                    Socios comerciales externos a los que accede a través de los
                    Servicios
                  </b>
                </th>
                <th>
                  <ul>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Compartiremos ciertos Datos personales si elige utilizar
                        cualquier servicio para iniciar sesión en los Servicios.
                      </span>
                    </li>
                    <li style={{"font-weight": "400"}} aria-level="1">
                      <span style={{"font-weight": "400"}}>
                        Para cumplir o cumplir con el motivo por el que nos
                        proporcionó la información.
                      </span>
                    </li>
                  </ul>
                </th>
              </tr>
            </thead>
          </table>
          <p>&nbsp;</p>
          <h3>
            <span style={{"font-weight": "400"}}>
              LAS SIGUIENTES SECCIONES SE APLICAN TANTO A LOS USUARIOS COMO A
              LOS PROVEEDORES DE ATENCIÓN MÉDICA.
            </span>
          </h3>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <i>
              <span style={{"font-weight": "400"}}>Transferencias comerciales</span>
            </i>
          </p>
          <p>
            <span style={{"font-weight": "400"}}>
              Todos los Datos personales pueden transferirse a un tercero si nos
              sometemos a una fusión, adquisición, quiebra u otra transacción en
              la que ese tercero asuma el control de nuestro negocio (en su
              totalidad o en parte).&nbsp;En caso de que ocurra uno de estos
              eventos, haremos todos los esfuerzos razonables para notificarle
              antes de que su información quede sujeta a diferentes políticas y
              prácticas de privacidad y seguridad.
            </span>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <h3>
            <span style={{"font-weight": "400"}}>
              Herramientas de seguimiento, publicidad y exclusión voluntaria
            </span>
          </h3>
          <p>
            <span style={{"font-weight": "400"}}>
              Las siguientes secciones brindan información adicional sobre cómo
              recopilamos sus Datos personales.
            </span>
          </p>
          <p>
            <i>
              <span style={{"font-weight": "400"}}>
                Información recopilada automáticamente
              </span>
            </i>
          </p>
          <p>
            <span style={{"font-weight": "400"}}>
              Los Servicios utilizan cookies y tecnologías similares, como
              etiquetas de píxeles, balizas web, GIF transparentes,
              identificadores móviles y JavaScript (colectivamente, «Cookies»)
              para permitir que nuestros servidores reconozcan su navegador web
              y nos digan cómo y cuándo visita y utiliza nuestro
              Servicios.&nbsp;Hacemos esto para analizar tendencias, conocer y
              anunciar a nuestra base de usuarios, y operar y mejorar nuestros
              Servicios.&nbsp;Por ejemplo, usamos Cookies para adaptar los
              Servicios o personalizar los anuncios mediante el seguimiento de
              los hábitos de navegación, la medición del rendimiento, el
              almacenamiento del estado de autenticación para que no sea
              necesario volver a ingresar las credenciales, la personalización
              de las experiencias del usuario con los Servicios y para el
              análisis y la prevención del fraude.&nbsp;Las cookies son pequeños
              fragmentos de datos, generalmente archivos de texto, que se
              colocan en su computadora, tableta, teléfono o dispositivo similar
              cuando usa ese dispositivo para visitar nuestros Servicios.
            </span>
          </p>
          <p>
            <span style={{"font-weight": "400"}}>
              Utilizamos los siguientes tipos de Cookies:
            </span>
          </p>
          <ul>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>Galletas esenciales</span>
              <span style={{"font-weight": "400"}}>
                &nbsp;.&nbsp;Las cookies esenciales son necesarias para
                proporcionarle funciones o servicios que haya
                solicitado.&nbsp;Por ejemplo, ciertas Cookies le permiten
                iniciar sesión en las áreas seguras de nuestros
                Servicios.&nbsp;La desactivación de estas cookies puede hacer
                que ciertas funciones y servicios no estén disponibles.
              </span>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>Cookies funcionales</span>
              <span style={{"font-weight": "400"}}>
                &nbsp;.&nbsp;Las cookies funcionales se utilizan para registrar
                sus elecciones y configuraciones con respecto a nuestros
                Servicios, mantener sus preferencias a lo largo del tiempo y
                reconocerlo cuando regrese a nuestros Servicios.&nbsp;Estas
                cookies nos ayudan a personalizar nuestro contenido para usted,
                saludarlo por su nombre y recordar sus preferencias (por
                ejemplo, su elección de idioma o región).
              </span>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>
                Cookies analíticas/de rendimiento
              </span>
              <span style={{"font-weight": "400"}}>
                .&nbsp;Las cookies de rendimiento/analíticas nos permiten
                comprender cómo los visitantes usan nuestros Servicios, por
                ejemplo, al recopilar información sobre la cantidad de
                visitantes a los Servicios, qué páginas ven los visitantes en
                nuestros Servicios, cuánto tiempo los visitantes ven páginas en
                los Servicios, clics del mouse, movimientos del mouse ,
                actividad de desplazamiento y texto escrito en los
                Servicios.&nbsp;Las cookies de rendimiento/analíticas también
                nos ayudan a medir el rendimiento de nuestras campañas
                publicitarias para ayudarnos a mejorar nuestras campañas y el
                contenido para aquellos que interactúan con nuestra
                publicidad.&nbsp;Por ejemplo, Google Inc. («Google») utiliza
                cookies en relación con sus servicios de Google
                Analytics.&nbsp;La capacidad de Google para usar y compartir
                información recopilada por Google Analytics sobre sus visitas a
                los Servicios está sujeta a los Términos de uso de Google
                Analytics y la Política de privacidad de Google.
              </span>
              <a href="https://www.google.com/privacy_ads.html">
                <span style={{"font-weight": "400"}}>
                  https://www.google.com/privacy_ads.html
                </span>
              </a>
              <span style={{"font-weight": "400"}}>
                &nbsp;o el complemento de inhabilitación para navegadores de
                Google Analytics en&nbsp;
              </span>
              <a href="https://tools.google.com/dlpage/gaoptout/">
                <span style={{"font-weight": "400"}}>
                  https://tools.google.com/dlpage/gaoptout/
                </span>
              </a>
              <span style={{"font-weight": "400"}}>&nbsp;.</span>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>
                Cookies de retargeting/publicidad
              </span>
              <span style={{"font-weight": "400"}}>
                &nbsp;.&nbsp;Las cookies de retargeting/publicidad recopilan
                datos sobre su actividad en línea e identifican sus intereses
                para que podamos brindarle publicidad que creemos que es
                relevante para usted.&nbsp;Para obtener más información al
                respecto, consulte la sección a continuación titulada
                «Información sobre anuncios basados ​​en intereses».
              </span>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>Balizas web</span>
              <span style={{"font-weight": "400"}}>
                &nbsp;.&nbsp;Las balizas web (por ejemplo, GIF transparentes o
                etiquetas de píxeles) son pequeños archivos de imágenes gráficas
                incrustadas en una página web o correo electrónico que se pueden
                usar para recopilar información sobre el uso de nuestros
                Servicios, los servicios web de anunciantes seleccionados y los
                correos electrónicos, promociones especiales , o boletines que
                enviamos.&nbsp;La información recopilada por Web Beacons nos
                permite analizar cuántas personas están utilizando los
                Servicios, utilizando los servicios web de editores
                seleccionados o abriendo correos electrónicos, y con qué
                propósito, y también nos permite mejorar nuestra publicidad
                basada en intereses (discutido más adelante).
              </span>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>
                Identificadores de dispositivos móviles
              </span>
              <span style={{"font-weight": "400"}}>
                &nbsp;.&nbsp;Los identificadores de dispositivos móviles ayudan
                a LA PLATAFORMA a obtener más información sobre la demografía y
                el comportamiento en Internet de nuestros Usuarios.&nbsp;Los
                identificadores de dispositivos móviles son datos almacenados en
                dispositivos móviles que pueden rastrear el dispositivo móvil y
                los datos y actividades que ocurren en él y a través de él, así
                como las aplicaciones instaladas en él.&nbsp;Los identificadores
                de dispositivos móviles permiten la recopilación de Datos
                personales, como el control de acceso a los medios, la dirección
                y la ubicación, y los datos de seguimiento, incluidos, entre
                otros, la dirección IP, el servidor de dominio, el tipo de
                dispositivo utilizado para acceder a los Servicios, el navegador
                web utilizado. para acceder a los Servicios, la página web de
                referencia u otra fuente a través de la cual accedió a los
                Servicios, otras estadísticas e información asociada con la
                interacción entre su navegador o dispositivo y los Servicios.
              </span>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>
                Coincidencia de dispositivos cruzados
              </span>
              <span style={{"font-weight": "400"}}>
                &nbsp;.&nbsp;Para determinar si los usuarios han interactuado
                con el contenido en varios dispositivos y para hacer coincidir
                dichos dispositivos, podemos trabajar con socios que analizan
                los datos de actividad del dispositivo y/o confían en su
                información (incluidos los datos demográficos, geográficos y
                basados ​​en intereses).&nbsp;Para complementar este análisis,
                también podemos proporcionar datos no identificados a estos
                socios.&nbsp;En función de estos datos, podemos mostrar anuncios
                dirigidos a través de dispositivos que creemos que están
                asociados, o usar estos datos para analizar más a fondo el uso
                de los Servicios en todos los dispositivos.
              </span>
            </li>
          </ul>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <span style={{"font-weight": "400"}}>
              Puede decidir si acepta o no las Cookies a través de la
              configuración de su navegador de Internet.&nbsp;La mayoría de los
              navegadores tienen una opción para desactivar la función de
              cookies, lo que evitará que su navegador acepte nuevas cookies y
              (dependiendo del software de su navegador) le permitirá decidir
              sobre la aceptación de cada nueva cookie de varias
              maneras.&nbsp;También puede rechazar los identificadores de
              dispositivos móviles activando la configuración adecuada en su
              dispositivo móvil.&nbsp;También puede eliminar todas las Cookies
              que ya están en su computadora.&nbsp;Aunque no está obligado a
              aceptar las Cookies de LA PLATAFORMA, si las bloquea, las rechaza
              o las elimina, es posible que deba ajustar manualmente algunas
              preferencias cada vez que acceda a los Servicios, ya que es
              posible que algunas funcionalidades no funcionen.
            </span>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <span style={{"font-weight": "400"}}>
              Para explorar qué configuraciones de cookies están disponibles
              para usted, busque en la sección «preferencias» u «opciones» del
              menú de su navegador.&nbsp;Para obtener más información sobre las
              cookies, incluida la información sobre cómo administrar y eliminar
              las cookies, visite&nbsp;
            </span>
            <a href="http://www.allaboutcookies.org/">
              <span style={{"font-weight": "400"}}>
                http://www.allaboutcookies.org/
              </span>
            </a>
            <span style={{"font-weight": "400"}}>&nbsp;.</span>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <i>
              <span style={{"font-weight": "400"}}>
                Información sobre anuncios basados ​​en intereses:
              </span>
            </i>
          </p>
          <p>
            <span style={{"font-weight": "400"}}>
              Podemos publicar anuncios y también permitir que redes
              publicitarias de terceros, incluidos servidores de anuncios de
              terceros, agencias de publicidad, proveedores de tecnología
              publicitaria y firmas de investigación, publiquen anuncios a
              través de los Servicios.&nbsp;Estos anuncios pueden estar
              dirigidos a usuarios que se ajustan a ciertas categorías de perfil
              general o muestran ciertas preferencias o comportamientos
              («Anuncios basados ​​en intereses»).&nbsp;Usted puede
              proporcionarnos la información para anuncios basados ​​en
              intereses (incluidos los datos personales), o puede derivarse o
              inferirse de la actividad en línea o patrones de uso de usuarios
              particulares en los Servicios y/o servicios de
              terceros.&nbsp;Dicha información puede incluir la dirección IP, la
              identificación del dispositivo móvil, el sistema operativo, el
              navegador, las interacciones de la página web, la ubicación
              geográfica y la información demográfica, como el género y el rango
              de edad.&nbsp;Dicha información se puede recopilar mediante el
              seguimiento de las actividades de los usuarios a lo largo del
              tiempo y las propiedades no afiliadas, incluso cuando abandona los
              Servicios.&nbsp;Para lograr esto, nosotros o nuestros proveedores
              de servicios podemos enviarle Cookies, incluidas las balizas web,
              desde una red publicitaria a través de los Servicios.&nbsp;Las
              balizas web permiten que las redes publicitarias brinden
              auditorías, investigaciones e informes agregados y anónimos para
              nosotros y para los anunciantes.&nbsp;Esta información ayuda a LA
              PLATAFORMA a obtener más información sobre la demografía y el
              comportamiento en Internet de nuestros Usuarios.&nbsp;Las balizas
              web también permiten que las redes publicitarias le muestren
              anuncios dirigidos cuando visita otros sitios web.&nbsp;Las
              balizas web permiten que las redes publicitarias vean, editen o
              establezcan sus propias cookies en su navegador, como si hubiera
              solicitado una página web desde su sitio.&nbsp;Para lograr esto,
              nosotros o nuestros proveedores de servicios podemos enviarle
              Cookies, incluidas las balizas web, desde una red publicitaria a
              través de los Servicios.&nbsp;Las balizas web permiten que las
              redes publicitarias brinden auditorías, investigaciones e informes
              agregados y anónimos para nosotros y para los
              anunciantes.&nbsp;Esta información ayuda a LA PLATAFORMA a obtener
              más información sobre la demografía y el comportamiento en
              Internet de nuestros Usuarios.&nbsp;Las balizas web también
              permiten que las redes publicitarias le muestren anuncios
              dirigidos cuando visita otros sitios web.&nbsp;Las balizas web
              permiten que las redes publicitarias vean, editen o establezcan
              sus propias cookies en su navegador, como si hubiera solicitado
              una página web desde su sitio.&nbsp;Para lograr esto, nosotros o
              nuestros proveedores de servicios podemos enviarle Cookies,
              incluidas las balizas web, desde una red publicitaria a través de
              los Servicios.&nbsp;Las balizas web permiten que las redes
              publicitarias brinden auditorías, investigaciones e informes
              agregados y anónimos para nosotros y para los
              anunciantes.&nbsp;Esta información ayuda a LA PLATAFORMA a obtener
              más información sobre la demografía y el comportamiento en
              Internet de nuestros Usuarios.&nbsp;Las balizas web también
              permiten que las redes publicitarias le muestren anuncios
              dirigidos cuando visita otros sitios web.&nbsp;Las balizas web
              permiten que las redes publicitarias vean, editen o establezcan
              sus propias cookies en su navegador, como si hubiera solicitado
              una página web desde su sitio.&nbsp;investigación e informes para
              nosotros y para los anunciantes.&nbsp;Esta información ayuda a LA
              PLATAFORMA a obtener más información sobre la demografía y el
              comportamiento en Internet de nuestros Usuarios.&nbsp;Las balizas
              web también permiten que las redes publicitarias le muestren
              anuncios dirigidos cuando visita otros sitios web.&nbsp;Las
              balizas web permiten que las redes publicitarias vean, editen o
              establezcan sus propias cookies en su navegador, como si hubiera
              solicitado una página web desde su sitio.&nbsp;investigación e
              informes para nosotros y para los anunciantes.&nbsp;Esta
              información ayuda a LA PLATAFORMA a obtener más información sobre
              la demografía y el comportamiento en Internet de nuestros
              Usuarios.&nbsp;Las balizas web también permiten que las redes
              publicitarias le muestren anuncios dirigidos cuando visita otros
              sitios web.&nbsp;Las balizas web permiten que las redes
              publicitarias vean, editen o establezcan sus propias cookies en su
              navegador, como si hubiera solicitado una página web desde su
              sitio.
            </span>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <span style={{"font-weight": "400"}}>
              Tenga en cuenta que incluso después de optar por no recibir
              anuncios basados ​​en intereses, es posible que siga viendo
              anuncios de LA PLATAFORMA que no están basados ​​en intereses (es
              decir, que no están dirigidos a usted).&nbsp;Además, la exclusión
              voluntaria no significa que LA PLATAFORMA ya no utilice
              herramientas de seguimiento: LA PLATAFORMA aún puede recopilar
              información sobre su uso de los Servicios incluso después de que
              haya optado por no recibir Anuncios basados ​​en intereses y aún
              puede mostrarle anuncios a través de los Servicios basados ​​en
              información recopilada a través de los Servicios.
            </span>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <h3>
            <span style={{"font-weight": "400"}}>
              Seguridad y retención de datos
            </span>
          </h3>
          <p>
            <span style={{"font-weight": "400"}}>
              La seguridad de sus Datos Personales es importante para
              nosotros.&nbsp;Buscamos proteger sus Datos personales del acceso,
              uso y divulgación no autorizados utilizando medidas de seguridad
              físicas, técnicas, organizacionales y administrativas apropiadas
              según el tipo de Datos personales y cómo los procesamos.&nbsp;Nos
              esforzamos por seguir los estándares de la industria generalmente
              aceptados para proteger los Datos personales que se nos envían,
              tanto durante la transmisión como durante el
              almacenamiento.&nbsp;Por ejemplo, los Servicios utilizan la
              tecnología Secure Sockets Layer (SSL) estándar de la industria
              para permitir el cifrado de Datos personales.&nbsp;Almacenamos y
              procesamos su información en nuestros servidores en los Estados
              Unidos y en el extranjero.&nbsp;Mantenemos lo que consideramos
              sistemas de respaldo y archivo estándar de la
              industria.&nbsp;También debe ayudar a proteger sus datos
              seleccionando y protegiendo adecuadamente su contraseña y/u otro
              mecanismo de inicio de sesión;&nbsp;limitar el acceso a su
              computadora o dispositivo y navegador;&nbsp;y cerrar la sesión
              después de que haya terminado de acceder a su cuenta.&nbsp;Aunque
              trabajamos para proteger la seguridad de su cuenta y otros datos
              que tenemos en nuestros registros, por ejemplo, haciendo esfuerzos
              de buena fe para almacenar Datos personales en un entorno
              operativo seguro que no está abierto al público, tenga en cuenta
              que no El método de transmisión de datos a través de Internet o de
              almacenamiento de datos es completamente seguro.&nbsp;No podemos
              garantizar y no garantizamos la seguridad total de los datos que
              comparte con nosotros y, salvo que la ley lo exija expresamente,
              no somos responsables del robo, la destrucción, la pérdida o la
              divulgación inadvertida de su información o contenido.
            </span>
          </p>
          <p>
            <span style={{"font-weight": "400"}}>
              Si en algún momento durante o después de nuestra relación creemos
              que la seguridad de sus Datos personales puede haberse visto
              comprometida, podemos intentar notificarle sobre ese
              desarrollo.&nbsp;Si una notificación es apropiada, haremos todo lo
              posible para notificarle tan pronto como sea posible dadas las
              circunstancias.&nbsp;Si tenemos su dirección de correo
              electrónico, podemos notificarle por correo electrónico a la
              dirección de correo electrónico más reciente que nos haya
              proporcionado en el perfil de su cuenta.&nbsp;Por favor, mantenga
              actualizada su dirección de correo electrónico en su
              cuenta.&nbsp;Puede actualizar esa dirección de correo electrónico
              en cualquier momento en el perfil de su cuenta.&nbsp;Si recibe un
              aviso de nuestra parte, puede imprimirlo para conservar una
              copia.&nbsp;Para recibir estos avisos, debe verificar su cuenta de
              correo electrónico usando su computadora o dispositivo móvil y el
              software de la aplicación de correo electrónico.{" "}
            </span>
            <b>
              Usted acepta nuestro uso del correo electrónico como medio de
              dicha notificación.&nbsp;&nbsp;
            </b>
            <span style={{"font-weight": "400"}}>&nbsp;&nbsp;</span>
          </p>
          <p>
            <span style={{"font-weight": "400"}}>
              Conservamos los datos personales sobre usted de conformidad con
              todas las políticas y procedimientos internos.&nbsp;Podemos
              retener Datos personales para cumplir con nuestras obligaciones
              legales, resolver disputas o cobrar tarifas adeudadas, o según lo
              permitan o exijan nuestras políticas y procedimientos de retención
              de datos.
            </span>
          </p>
          <h3>
            <span style={{"font-weight": "400"}}>Privacidad de los niños</span>
          </h3>
          <p>
            <span style={{"font-weight": "400"}}>
              Los Servicios no están dirigidos ni destinados a ser utilizados
              por niños menores de 13 años.&nbsp;Si es un niño menor de 13 años,
              no intente registrarse o utilizar los Servicios de otra manera ni
              enviarnos Datos personales.&nbsp;
            </span>
            <span style={{"font-weight": "400"}}>
              Al acceder, usar y/o enviar información a través de los Servicios,
              usted declara que no es menor de 13 años. Como se indica en
              los&nbsp;
            </span>
            <a href="https://24siete.app/terminos-de-uso/">
              <span style={{"font-weight": "400"}}>Términos de uso</span>
            </a>
            <span style={{"font-weight": "400"}}>
              , no recopilamos ni solicitamos a sabiendas Datos personales de
              niños menores de 13 años. Si nos enteramos de que hemos recibido
              Datos personales directamente de un niño menor de 13 años sin
              recibir primero el consentimiento verificado de sus padres,
              utilizaremos esos Datos personales. Datos solo para responder
              directamente a ese niño (o a su padre o tutor legal) para
              informarle que no puede usar los Servicios.&nbsp;Posteriormente,
              eliminaremos los Datos personales de ese niño.&nbsp;Si cree que un
              niño menor de 13 años puede habernos proporcionado Datos
              personales, contáctenos en{" "}
            </span>
            <a href="mailto:soporte@24siete.app">
              <span style={{"font-weight": "400"}}>soporte@24siete.app</span>
            </a>
            <span style={{"font-weight": "400"}}>.</span>
          </p>
          <p>
            <span style={{"font-weight": "400"}}>
              Si tiene entre trece (13) años y la mayoría de edad en su lugar de
              residencia, puede usar los Servicios solo con el consentimiento o
              bajo la supervisión de su padre o tutor legal.&nbsp;Si es padre o
              tutor legal de un niño menor de edad, puede, de conformidad con el
              Acuerdo, utilizar los Servicios en nombre de dicho niño menor de
              edad.&nbsp;Cualquier información que nos proporcione mientras usa
              los Servicios en nombre de su hijo menor se tratará como Datos
              personales, tal como se establece en este documento.
            </span>
          </p>
          <p>
            <span style={{"font-weight": "400"}}>
              Si utiliza los Servicios en nombre de otra persona,
              independientemente de su edad, acepta que LA PLATAFORMA puede
              contactarlo para cualquier comunicación realizada en relación con
              la prestación de los Servicios o cualquier comunicación legalmente
              requerida.&nbsp;Además, acepta reenviar o compartir dicha
              comunicación con cualquier persona para la que esté utilizando los
              Servicios en nombre.
            </span>
          </p>
          <h3>
            <span style={{"font-weight": "400"}}>
              Cómo usamos la información que no son datos personales&nbsp;
            </span>
          </h3>
          <p>
            <span style={{"font-weight": "400"}}>
              Cierta información que LA PLATAFORMA recopila puede no ser Datos
              personales ni información médica del paciente, incluida la
              información que no incluye ninguna información identificable en la
              recopilación o que hemos desidentificado y/o agregado de Datos
              personales.&nbsp;Podemos usar esta información para cualquier
              propósito permitido por la ley aplicable, incluidos, entre otros,
              para comprender mejor quién usa LA PLATAFORMA y cómo podemos
              brindar una mejor experiencia de atención médica digital.
            </span>
          </p>
          <h3>
            <span style={{"font-weight": "400"}}>
              Control de sus datos personales y notificaciones
            </span>
          </h3>
          <p>
            <span style={{"font-weight": "400"}}>
              Si es un usuario registrado de los Servicios, puede modificar
              ciertos Datos personales o información de la cuenta iniciando
              sesión y accediendo a su cuenta.&nbsp;Si desea cerrar su cuenta,
              envíenos un correo electrónico a soporte@24siete.app.
            </span>
            <span style={{"font-weight": "400"}}>&nbsp;</span>
            <span style={{"font-weight": "400"}}>
              LA PLATAFORMA hará todos los esfuerzos razonables para eliminar su
              cuenta tan pronto como sea razonablemente posible.&nbsp;Sin
              embargo, tenga en cuenta que LA PLATAFORMA se reserva el derecho
              de retener información de cuentas cerradas de acuerdo con nuestras
              políticas y procedimientos internos de retención de datos.
            </span>
          </p>
          <p>
            <span style={{"font-weight": "400"}}>
              Debe notificarnos de inmediato si alguno de los datos de su cuenta
              se pierde, es robado o se usa sin permiso.
            </span>
          </p>
          <p>
            <span style={{"font-weight": "400"}}>
              La participación en el incentivo económico es totalmente
              opcional.&nbsp;Si participa en un incentivo financiero, acepta que
              no estamos obligados a cumplir con su derecho a conocer o eliminar
              la información personal recopilada a cambio del incentivo
              financiero.&nbsp;Si participa en un incentivo financiero que
              ofrecemos, puede retirarse del incentivo financiero en cualquier
              momento enviándonos un correo electrónico a la dirección de correo
              electrónico que se le proporcionó con su aviso individual de
              incentivo financiero.
            </span>
          </p>
          <h3>
            <span style={{"font-weight": "400"}}>
              Cambios a esta Política de Privacidad
            </span>
          </h3>
          <p>
            <span style={{"font-weight": "400"}}>
              Nos reservamos el derecho de modificar nuestra Política de
              Privacidad a nuestra discreción y en cualquier
              momento.&nbsp;Cuando realicemos cambios en la Política de
              privacidad, se lo notificaremos por correo electrónico o a través
              de un aviso en la página de inicio de nuestro sitio web.&nbsp;El
              uso de la información que recopilamos está sujeto a la Política de
              privacidad vigente en el momento en que se recopila dicha
              información.
            </span>
          </p>
          <h3>
            <span style={{"font-weight": "400"}}>Información del contacto</span>
          </h3>
          <p>
            <span style={{"font-weight": "400"}}>
              Si tiene alguna pregunta o comentario sobre esta Política de
              privacidad, las formas en que recopilamos y usamos sus Datos
              personales, sus opciones y derechos con respecto a dicho uso, no
              dude en comunicarse con nosotros en:
            </span>
          </p>
          <ul>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>Correo electrónico:</span>{" "}
              <a
                title="soporte@citamedica.app"
                href="mailto:soporte@citamedica.app"
              >
                soporte@citamedica.app
              </a>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>
                Dirección: Caracas, Venezuela.
              </span>
            </li>
            <li style={{"font-weight": "400"}} aria-level="1">
              <span style={{"font-weight": "400"}}>Teléfono: (+58) 414 8683000</span>
            </li>
          </ul>
          <p>&nbsp;</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicies;
